/**
 * ui-router 0.4.3 `reload` value that re-enters only the parent of `currentStateName`,
 * for the `$state.go('^', …)` dismiss the modal dialogs use.
 *
 * A boolean `true` matches neither branch of transitionTo's keep-loop, so `keep` stays 0
 * and every state in the path is torn down and re-entered -- which is what made a trust
 * save re-resolve the clients list, client and matter states. Only a non-empty state name
 * takes the targeted branch: `''` is falsy and refreshes nothing at all.
 *
 * Pass the state being navigated away from, resolved at call time, so the reload root and
 * the `'^'` target can never disagree. A top-level state has no ancestor to keep, so it
 * falls back to `true` -- already equivalent there, since `path` excludes the root.
 */
export function reloadParentOnly(currentStateName?: string | null): string | true {
  const lastDot = currentStateName ? currentStateName.lastIndexOf('.') : -1;
  return lastDot > 0 ? (currentStateName as string).slice(0, lastDot) : true;
}
